export default __webpack_public_path__ + "static/media/our-services-edu-special-education.13d67cfd.jpg";